import { render, staticRenderFns } from "./CampaignItemPaymentMethods.vue?vue&type=template&id=04b87eb6&"
import script from "./CampaignItemPaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./CampaignItemPaymentMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports